<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="false"
      :hideEdit="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onViewClicked="onViewClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '../directives/button-options';

export default {
  name: 'CompanyEdit',
  components: { ButtonOptions },
  props: ['access', 'company'],
  data() {
    return {
      isSubmit: false,
    };
  },
  computed: {
    data() {
      return { ...this.company };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.data);
    },
    onViewClicked() {
      this.$emit('onViewClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
